import { apiDaInscricao } from "../../../servicos/axios";

export type ApiAgendamento = {
  id: number;
  dataInicial: string;
  dateFinal?: string;
  status: string;
  pessoa: {
    nome: string;
    cpf?: string;
    telefoneCelular?: string;
  };
};

export const buscarAgenda = async (ano: number, mesIndex0: number) => {
  const mes = String(mesIndex0 + 1).padStart(2, "0");

  const data = `${ano}-${mes}-01`;

  const api = apiDaInscricao();

  const response = await api.get("/agendamento/ObterAgendamentos?data=" + data);

  return (response.data?.agendamentos ?? []) as ApiAgendamento[];
};
